import { TableCell, TableHead, TableRow } from "@mui/material";

export default function PaymentsTableHeader({ showActions = true }) {
  return (
    <TableHead>
      <TableRow>
        <TableCell className="font-bold" align="center">
          &nbsp;
        </TableCell>
        <TableCell className="font-bold">Valid From</TableCell>
        <TableCell className="font-bold">Valid To</TableCell>
        <TableCell className="font-bold">Payment Method</TableCell>
        <TableCell className="font-bold">Bank Name</TableCell>
        {showActions && (
          <TableCell className="font-bold" align="right">
            &nbsp;
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}
